import { ReactElement } from "react";

import { ICatalogueCustomizationsOptions } from "../../../apis/useGetCatalogueData/types";
import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";

interface IProps {
	options: ICatalogueCustomizationsOptions[];
}

const CartItemCustomizationOptions = ({ options }: IProps): ReactElement => {
	return (
		<ul className="Options">
			{options.map((option) => (
				<li className="Option" key={option.id}>
					<I18nText className="OptionTitle" enText={option.title} cnText={option.title_cn} />
					<Condition check={(option.price_diff ?? 0) > 0}>
						<span className="OptionPrice TabularNums">{`+ $${centsToDollarsDisplay(option.price_diff)}`}</span>
					</Condition>
				</li>
			))}
		</ul>
	);
};

export default CartItemCustomizationOptions;
